import * as React from 'react';
import {connect} from 'react-redux';
import * as ReportModule from 'Modules/ReportModule';
import {withTranslation} from 'react-i18next';
import {ParentDetails, CustomProps, IParentDetailsProps} from 'components/Layout/DetailsSidebar/ParentDetails';
import ActiveTerminalsReportForm from "components/Layout/Form/ActiveTerminalsReportForm";
import {createSerachQuery} from 'Connectors/_main';
import {activeTerminalsReportForm} from "Models/ReportModel";

interface IP extends IParentDetailsProps {
    history: any;
}

type ConnectedP = {
    reportStore: ReportModule.Types.ReportStore;
};
type DispatchedP = {
    getActiveTerminalsReport: (params: URLSearchParams) => void;
    getReportFile: (extension: ReportModule.EnumTypes.ReportExtension, type: ReportModule.EnumTypes.ReportType, params?: URLSearchParams) => void;
    t?: (key: string) => string;
};
type S = {};

class ActiveTerminalsReportDetails extends ParentDetails<IP & ConnectedP & DispatchedP, S> {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public getCustomProps(): CustomProps {
        return {
            ...(this.props as any),
            extrnalRender: () => this.extrnalRender()
        };
    }

    private async handleSubmit(formData: activeTerminalsReportForm) {
        const {getActiveTerminalsReport} = this.getCustomProps();
        const params = createSerachQuery(formData);
        await getActiveTerminalsReport(params);
    }

    private extrnalRender() {
        const {getReportFile, reportStore, t} = this.getCustomProps();
        const {PDF, CSV, XLSX} = ReportModule.EnumTypes.ReportExtension;
        const {ACTIVE_TERMINALS_REPORT} = ReportModule.EnumTypes.ReportType;
        return (
            <>
                <ActiveTerminalsReportForm
                    onSubmit={this.handleSubmit}
                />
                <div className="report__generate-file">
                    <button disabled={reportStore.activeTerminalsReport === null}
                            className="report__button btn btn--clean"
                            onClick={() => getReportFile(PDF, ACTIVE_TERMINALS_REPORT)}>
                        <img src={'/images/icons/pdf_icon.svg'} alt="PDF" className="report__button-img"/>
                        <span>{t('exportToPDF')}</span>
                    </button>
                    <button disabled={reportStore.activeTerminalsReport === null}
                            className="report__button btn btn--clean"
                            onClick={() => getReportFile(CSV, ACTIVE_TERMINALS_REPORT)}>
                        <img src={'/images/icons/csv_icon.svg'} alt="CSV" className="report__button-img"/>
                        <span>{t('exportToCSV')}</span>
                    </button>
                    <button disabled={reportStore.activeTerminalsReport === null}
                            className="report__button btn btn--clean"
                            onClick={() => getReportFile(XLSX, ACTIVE_TERMINALS_REPORT)}>
                        <img src={'/images/icons/xls_icon.svg'} alt="XLS" className="report__button-img"/>
                        <span>{t('exportToXLS')}</span>
                    </button>
                </div>
            </>
        );
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        reportStore: state.reportStore
    };
}

function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        getActiveTerminalsReport: (params: URLSearchParams) => dispatch(ReportModule.Actions.getActiveTerminalsReport(params)),
        getReportFile: (extension: ReportModule.EnumTypes.ReportExtension, type: ReportModule.EnumTypes.ReportType, params?: URLSearchParams) =>
            dispatch(ReportModule.Actions.getReportFile(extension, type, params)),
    };
}

export default withTranslation('reports')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(ActiveTerminalsReportDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/ActiveTerminalsReportDetails.tsx